import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from './index';
import { API_ICARDIO } from 'constants/env.const';

export const authAPI = createApi({
  reducerPath: 'authAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: API_ICARDIO,
    prepareHeaders: prepareHeaders,
    credentials: 'include',
  }),
  tagTypes: ['User'],
  endpoints: builder => ({
    login: builder.mutation<void, string>({
      query: (token: string) => {
        return {
          url: '/session_login/',
          method: 'POST',
          body: { accessToken: token },
          headers: {
            'Content-Type': 'application/json',
          },
        };
      },
      invalidatesTags: [{ type: 'User', id: 'current' }],
    }),
  }),
});
export const { useLoginMutation } = authAPI;
